import axios from 'axios';
import router from '@/router';

class Api {
  constructor() {
    this.setToken();
    this.setupInterceptors();
  }

  setToken() {
    const token = window.localStorage.getItem('token');
    const userData = window.localStorage.getItem('user');

    if (token && userData && userData !== 'undefined') {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
      axios.defaults.headers.common['api-token'] = token;
    } else {
      delete axios.defaults.headers.common['Authorization'];
      delete axios.defaults.headers.common['api-token'];
    }
  }

  setupInterceptors() {
    // Response interceptor to handle 401 Unauthorized globally
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        // Check if error is 401 Unauthorized
        if (error.response && error.response.status === 401) {
          // Clear authentication data
          window.localStorage.removeItem('token');
          window.localStorage.removeItem('user');

          // Clear axios headers
          delete axios.defaults.headers.common['Authorization'];
          delete axios.defaults.headers.common['api-token'];

          // Update auth service state
          if (window.auth) {
            window.auth.token = null;
            window.auth.user = null;
          }

          // Redirect to login page (avoid redirect loop)
          if (router.currentRoute.name !== 'Login') {
            router.push({
              name: 'Login',
              query: { redirect: router.currentRoute.fullPath }
            });
          }
        }

        // Re-throw error for component-level handling
        return Promise.reject(error);
      }
    );
  }

  async call(method, url, data = null) {
    try {
      const response = await axios({
        method,
        url,
        data,
        headers: data instanceof FormData ? {} : { 'Content-Type': 'application/json' }
      });
      return response;
    } catch (error) {

      // Note: 401 handling is now done by the interceptor (setupInterceptors)
      // which automatically clears localStorage and redirects to login

      // Re-throw proper error object for .catch usage in Vue
      if (error.response) {
        throw {
          status: error.response.data.status,
          data: error.response.data.title || error.response.data,
        };
      } else if (error.request) {
        throw {
          status: 0,
          data: 'No response received from server',
        };
      } else {
        throw {
          status: 0,
          data: error.message || 'Unexpected error occurred',
        };
      }
    }
  }
}

export default Api;
